// @ts-check

/**
 * Fixed destinations shared by the launcher and the browser configuration.
 * @param {string | undefined} backend
 * @param {string | undefined} region
 * @param {string} [port]
 * @returns {{ backend: 'stage' | 'dev', region: 'CZ' | 'PL', apiOrigin: string, websiteOrigin: string, proxyOrigin: string, apiProxyOrigin: string, proxyPort: number }}
 */
const getRemoteBackend = (backend, region, port = '4000') => {
  if (backend !== 'stage' && backend !== 'dev') {
    throw new Error('Backend must be stage or dev.')
  }
  if (region !== 'CZ' && region !== 'PL') {
    throw new Error('Region must be CZ or PL.')
  }
  if (!/^\d+$/.test(port) || Number(port) < 1 || Number(port) > 65535) {
    throw new Error('Proxy port must be between 1 and 65535.')
  }

  const domain = `${region.toLowerCase()}.twisto.${backend === 'stage' ? 'live' : 'wtf'}`
  const proxyPort = Number(port)
  const proxyOrigin = new URL(`http://localhost:${proxyPort}`).origin

  return {
    backend,
    region,
    apiOrigin: `https://api.${domain}`,
    websiteOrigin: `https://www.${domain}`,
    proxyOrigin,
    apiProxyOrigin: `${proxyOrigin}/api`,
    proxyPort,
  }
}

exports.getRemoteBackend = getRemoteBackend

// Next replaces these explicit public references in the browser bundle.
// A production build must never pick up a developer's local proxy settings.
exports.remoteBackend =
  process.env.NODE_ENV === 'development' &&
  process.env.NEXT_PUBLIC_REMOTE_BACKEND
    ? getRemoteBackend(
        process.env.NEXT_PUBLIC_REMOTE_BACKEND,
        process.env.NEXT_PUBLIC_REMOTE_REGION,
        process.env.NEXT_PUBLIC_REMOTE_PROXY_PORT
      )
    : undefined
